import axiosClient from "../api/axiosClient";

export const loginUser = async (credentials) => {
  const res = await axiosClient.post("/auth/login", credentials);

  const { token, user } = res.data;

  return res.data;
};

export const logoutUser = () => {
  localStorage.removeItem("token");
  //   localStorage.removeItem("user");
};

export const loginCapital = async (credentials) => {
  const res = await axiosClient.post("/auth/login/capital", credentials);

  const { token, user } = res.data;

  localStorage.setItem("token-capital", token);

  localStorage.setItem("user-capital", JSON.stringify(user));

  return res.data;
};

export const checckCapitalLogin = async () => {
  const token = localStorage.getItem("token-capital");

  if (token) {
    const response = await axiosClient.post("/auth/verify/capital", {
      token,
    });
    const data = response.data;

    console.log("Capital verify response ", response);
    if (data.success) {
      return true;
    } else {
      return false;
    }
  }
  return false;
};

export const updateCapitalCredentials = async (credentials) => {
  const res = await axiosClient.patch(
    "/auth/capital/updatepassword",
    credentials,
  );
  return res.data;
};
